import moment from "moment";

export const DATE_FORMAT = "MM/DD/YYYY";
export const HOUR_DATE_FORMAT = "MM/DD/YYYY, h:mm";
export const DASHED_DATE_FORMAT = "YYYY-MM-DD";
export const FULL_DATE_FORMAT = "dddd, MMM DD, YYYY hh:mm A";
export const DATE_TIME_FORMAT = "yyyy-MM-DD HH:mm:ss";
export const HOURS_AND_MINUTES_12_HOURS_FORMAT = "HH:mm A";
export const HOUR_DATE_12_HOURS_FORMAT = "MM/DD/YYYY, h:mm A";
export const HOURS_AND_MINUTES_FORMAT = "HH:mm";
export const DAY_MONTH_YEAR_FORMAT = "DD/MM/YYYY";
export const MONTH_DAY_FORMAT = "MMMM D, YYYY";
export const H_AND_MINUTES_12_HOURS_FORMAT = "h:mm A zz";
export const CST_TIMEZONE = "America/Chicago";

export function dateToString(
  date: moment.MomentInput,
  format: string = HOUR_DATE_FORMAT
) {
  return date ? moment(date).format(format) : "";
}

export function isDateBefore(
  firstDate: string | number | Date,
  secondDate: string | number | Date
) {
  const newFirstDate = new Date(firstDate);
  const newSecondDate = new Date(secondDate);

  return moment(newFirstDate).isBefore(newSecondDate);
}

export const disablePastDates = (val: any) => {
  return val >= new Date().toISOString().substr(0, 10);
};

export const formatDate = (date: any, format: string = DATE_FORMAT) => {
  return date ? moment(date).format(format) : "";
};

export const formatDateTimezone = (
  date: any,
  timezone: string = CST_TIMEZONE,
  format: string = DATE_FORMAT
) => {
  return date
    ? moment(date)
        // @ts-ignore
        .tz(timezone)
        .format(format)
    : "";
};

export const formatDateToISO = (date: any) => {
  return moment(date).toISOString();
};

export const getDateInMs = (date: number) => {
  const dateToFormat = date || new Date().getTime();
  return moment(dateToFormat).valueOf();
};
